import { render, staticRenderFns } from "./RecomendationResume.vue?vue&type=template&id=0303d1ad&"
import script from "./RecomendationResume.vue?vue&type=script&lang=js&"
export * from "./RecomendationResume.vue?vue&type=script&lang=js&"
import style0 from "./RecomendationResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports